/* MiniCool — Mais Vendidos: favoritos (localStorage) + quick view (Espreitar) */
(function () {
  var FKEY = 'mc-favs';
  function getFavs() { try { return JSON.parse(localStorage.getItem(FKEY)) || []; } catch (e) { return []; } }
  function setFavs(a) { try { localStorage.setItem(FKEY, JSON.stringify(a)); } catch (e) {} }

  function wire(root) {
    if (root.dataset.mcBsReady === '1') return;
    root.dataset.mcBsReady = '1';

    /* favoritos */
    var favs = getFavs();
    root.querySelectorAll('.mc-bs__fav').forEach(function (btn) {
      var id = btn.getAttribute('data-fav');
      if (favs.indexOf(id) !== -1) btn.classList.add('is-on');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        favs = getFavs();
        var i = favs.indexOf(id);
        if (i === -1) { favs.push(id); btn.classList.add('is-on'); }
        else { favs.splice(i, 1); btn.classList.remove('is-on'); }
        setFavs(favs);
      });
    });

    /* quick view */
    var modal = root.querySelector('.mc-bs__modal');
    if (!modal) return;
    var qImg = modal.querySelector('[data-qv-img]'),
        qBrand = modal.querySelector('[data-qv-brand]'),
        qTitle = modal.querySelector('[data-qv-title]'),
        qPrice = modal.querySelector('[data-qv-price]'),
        qCompare = modal.querySelector('[data-qv-compare]'),
        qDesc = modal.querySelector('[data-qv-desc]'),
        qVid = modal.querySelector('[data-qv-vid]'),
        qLink = modal.querySelector('[data-qv-link]'),
        qAddBtn = modal.querySelector('[data-qv-addbtn]');

    function openQV(d) {
      qImg.src = d.img || ''; qImg.alt = d.title || '';
      qBrand.textContent = d.brand || '';
      qTitle.textContent = d.title || '';
      qPrice.textContent = d.price || '';
      if (d.compare) { qCompare.textContent = d.compare; qCompare.style.display = ''; }
      else { qCompare.style.display = 'none'; }
      qDesc.textContent = d.desc || '';
      qLink.href = d.url || '#';
      qVid.value = d.vid || '';
      if (d.available === 'true') { qAddBtn.disabled = false; qAddBtn.textContent = 'Adicionar ao carrinho'; }
      else { qAddBtn.disabled = true; qAddBtn.textContent = 'Esgotado'; }
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeQV() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }

    root.querySelectorAll('[data-qv]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openQV({
          img: btn.getAttribute('data-img'),
          brand: btn.getAttribute('data-brand'),
          title: btn.getAttribute('data-title'),
          price: btn.getAttribute('data-price'),
          compare: btn.getAttribute('data-compare'),
          desc: btn.getAttribute('data-desc'),
          url: btn.getAttribute('data-url'),
          vid: btn.getAttribute('data-vid'),
          available: btn.getAttribute('data-available')
        });
      });
    });
    modal.querySelectorAll('[data-qv-close]').forEach(function (el) { el.addEventListener('click', closeQV); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });
  }

  function init() { document.querySelectorAll('.mc-bestsellers-section').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? (e.target.classList && e.target.classList.contains('mc-bestsellers-section') ? e.target : e.target.querySelector('.mc-bestsellers-section')) : null;
    if (el) wire(el);
  });
})();
